export class ActivityMetaKeys {
    public static readonly COMMENT = "comment";
    public static readonly PAIN_SCALE = "painScale";
    public static readonly BODY_WEIGHT = "body_weight"; // this is the clean/initial body weight when no additional weight load is added.
    public static readonly PLATE_VARIANT = "plate_variant";
    public static readonly REFERENCE_PROTOCOL_IDENTIFIER = "referenceProtocolIdentifier"; // this is an identifier that can associate an activity with a protocol (used for intents)
}
